import { switchMap, map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { SaleItem } from './sale-item'
import { saleItemActions } from './sale-item.actions'
import * as fromParticipation from './sale-item.reducer'
import { SaleItemService } from './sale-item.service'

@Injectable()
export class SaleItemEffects extends ResourceEffects<SaleItem> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public saleSaleItemService: SaleItemService,
    public router: Router
  ) {
    super(
      fromParticipation.FEATURE_NAME,
      saleSaleItemService,
      saleItemActions,
      actions$
    )
  }

  fetchOneBySaleId = createEffect(() =>
    this.actions$.pipe(
      ofType(saleItemActions.fetchOneBySaleId),
      switchMap((action) =>
        this.saleSaleItemService
          .getOneBySaleId(action.saleId, action.saleLine, action.params)
          .pipe(
            map((saleItem) =>
              normalizationActions.upsertMany({
                entities: normalizeToSchema({ saleItems: [saleItem] })
              })
            )
          )
      )
    )
  )

  fetchManyBySaleId = createEffect(() =>
    this.actions$.pipe(
      ofType(saleItemActions.fetchManyBySaleId),
      switchMap((action) =>
        this.saleSaleItemService
          .getManyBySaleId(action.saleId, action.params)
          .pipe(
            map((saleItems) =>
              normalizationActions.upsertMany({
                entities: normalizeToSchema({ saleItems })
              })
            )
          )
      )
    )
  )
}
